import { createStore, applyMiddleware, compose } from 'redux'
import { routerMiddleware } from 'react-router-redux'
import createSagaMiddleware, { END } from 'redux-saga'

import createHistory from 'history/createBrowserHistory'
import rootReducer from './reducers'

import appSaga from './sagas/app'

export const history = typeof window !== undefined ? createHistory() : {}
const initialState = typeof window !== undefined ? window.__awesome_data__ : {}

const sagaMiddleware = createSagaMiddleware()


const enhancers = []
const middleware = [
  sagaMiddleware,
  routerMiddleware(history)
]

if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = window.devToolsExtension

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension())
  }
}

const composedEnhancers = compose(
  applyMiddleware(...middleware),
  ...enhancers
)

const store = createStore(
  rootReducer,
  initialState,
  composedEnhancers
)

store.close = () => store.dispatch(END)
sagaMiddleware.run(appSaga)

export default store



// WEBPACK FOOTER //
// ./src/store.js